// @ts-strict-ignore
import { ArticlePrepareData } from './article-prepare-data';
import { Connection } from '@3d-scene/model3d/connection';

export class ConnectArticlePrepareData extends ArticlePrepareData {
  public acceptingConnections: Connection[];

  public constructor(vectorId: number, givingConnectionNames: string[]) {
    super(vectorId, givingConnectionNames);
  }
}
